const unitOfMeasureMapping = {
    listings: 'month',
    days: 'day',
};

const SingleFamilyContractDetails = ({
    customerId = '',
    name = '',
    unitCost = null,
    unitOfMeasure = '',
    productType = null,
} = {}) => ({
    customerId: String(customerId),
    name: String(name),
    unitCost: Number(unitCost),
    unitOfMeasure: String(unitOfMeasureMapping[unitOfMeasure]),
    productType: String(productType),
});

export default SingleFamilyContractDetails;
